import { TrendingUp, ShieldCheck, Mail, AlertTriangle } from "lucide-react";

export const SpfDkimDmarcKeyFindings = () => {
  const findings = [
    {
      icon: <ShieldCheck className="w-5 h-5" />,
      stat: "95%",
      label: "of phishing uses spoofed domains",
      description: "DMARC prevents attackers from impersonating your brand in email headers"
    },
    {
      icon: <Mail className="w-5 h-5" />,
      stat: "10-20%",
      label: "inbox rate improvement",
      description: "Properly configured authentication dramatically improves delivery rates"
    },
    {
      icon: <TrendingUp className="w-5 h-5" />,
      stat: "Feb 2024",
      label: "Google/Yahoo deadline",
      description: "Bulk senders now require DMARC with at least p=none policy"
    },
    {
      icon: <AlertTriangle className="w-5 h-5" />,
      stat: "73%",
      label: "of domains lack DMARC",
      description: "Most organizations are vulnerable to email spoofing attacks"
    }
  ];

  return (
    <section className="py-10 sm:py-12">
      <h2 className="font-display text-2xl sm:text-3xl font-bold text-foreground mb-8 text-center">
        Why Authentication Matters
      </h2>
      
      <div className="grid sm:grid-cols-2 gap-4">
        {findings.map((finding, index) => (
          <div key={index} className="bg-card rounded-xl border border-border p-5 hover:border-primary/30 transition-colors">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary flex-shrink-0">
                {finding.icon}
              </div>
              <div>
                <div className="flex items-baseline gap-2 mb-1">
                  <span className="text-2xl font-bold text-foreground">{finding.stat}</span>
                  <span className="text-sm text-muted-foreground">{finding.label}</span>
                </div>
                <p className="text-sm text-muted-foreground">{finding.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
